import { useState } from "react";

import { Grid } from "@mui/material";

import { LoadingButton } from "@aclymatepackages/atoms";

import EmissionsDetailsTableAccordion from "../../modules/tables/EmissionsDetailsTableAccordion";

import { fetchOurApi } from "../../../helpers/utils/apiCalls";

const FetchEmissionsTableBlock = ({
  type,
  emissions,
  id,
  name,
  showCharts,
  setShowCharts,
  setSelectedTransaction,
  onAccordionClick
}) => {
  const [transactionsLoading, setTransactionsLoading] = useState(false);
  const [transactions, setTransactions] = useState([]);

  const aggregatedEmissions =
    emissions && emissions.filter(({ source }) => source === "aggregated");

  if (!aggregatedEmissions?.length) {
    return (
      <EmissionsDetailsTableAccordion
        type={type}
        emissions={emissions}
        setSelectedTransaction={setSelectedTransaction}
        isExpanded={!showCharts}
        onChange={onAccordionClick}
        name={name}
      />
    );
  }

  const onFetchTaggedTransactions = async () => {
    setTransactionsLoading(true);
    const buyerId = window.sessionStorage.getItem("accountId");
    return await fetchOurApi({
      path: "/transactions/fetch-account-tagged-transactions",
      method: "POST",
      data: { buyerId, tag: type, tagId: id },
      callback: ({ transactions }) => {
        const nonAggregatedEmissions = emissions.filter(
          ({ source }) => source !== "aggregated"
        );
        setShowCharts(false);
        setTransactions([...transactions, ...nonAggregatedEmissions]);
        return setTransactionsLoading(false);
      }
    });
  };

  if (!transactions.length) {
    return (
      <Grid container justifyContent="center">
        <Grid item>
          <LoadingButton
            isLoading={transactionsLoading}
            label="Fetch All Emissions"
            onClick={onFetchTaggedTransactions}
          />
        </Grid>
      </Grid>
    );
  }

  return (
    <EmissionsDetailsTableAccordion
      emissions={transactions}
      setSelectedTransaction={setSelectedTransaction}
      type={type}
      isExpanded={!showCharts}
      onChange={onAccordionClick}
      name={name}
    />
  );
};
export default FetchEmissionsTableBlock;
